import { CartService } from '../cart/cart.service';
import { LivestreamService } from '../livestream/livestream.service';
import { LineItemService } from './line-item.service';
import { LineItemPropertyService } from './line-item-property.services';
import { UmgPromiseDateService } from './umg-promise-date.service';

class ShopifyService {
  private static instance: ShopifyService;

  private _cartService?: CartService;
  private _umgPromiseDateService?: UmgPromiseDateService;
  private _lineItemPropertyService?: LineItemPropertyService;
  private _lineItemService?: LineItemService;
  private _livestreamService?: LivestreamService;

  private constructor() {}

  static getInstance(): ShopifyService {
    if (!ShopifyService.instance) {
      ShopifyService.instance = new ShopifyService();
    }
    return ShopifyService.instance;
  }

  get cartService(): CartService {
    if (!this._cartService) {
      this._cartService = new CartService(this.lineItemService, this.livestreamService);
    }
    return this._cartService;
  }

  get lineItemService(): LineItemService {
    if (!this._lineItemService) {
      this._lineItemService = new LineItemService(this.lineItemPropertyService);
    }
    return this._lineItemService;
  }

  get lineItemPropertyService(): LineItemPropertyService {
    if (!this._lineItemPropertyService) {
      this._lineItemPropertyService = new LineItemPropertyService(this.umgPromiseDateService);
    }
    return this._lineItemPropertyService;
  }

  get umgPromiseDateService(): UmgPromiseDateService {
    if (!this._umgPromiseDateService) {
      this._umgPromiseDateService = new UmgPromiseDateService();
    }
    return this._umgPromiseDateService;
  }

  get livestreamService(): LivestreamService {
    if (!this._livestreamService) {
      this._livestreamService = new LivestreamService();
    }
    return this._livestreamService;
  }
}

export const shopifyService = ShopifyService.getInstance();
